//#region src/__generated__/internal/application/types/AssignmentPayload.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const assignmentPayloadSlotEnum = {
	NG_STAFF: "NG_STAFF",
	NTP_HEAD: "NTP_HEAD",
	NTP_RESPONSIBLE: "NTP_RESPONSIBLE"
};
//#endregion
//#region src/__generated__/internal/application/types/FileMetaDto.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSourceTypeEnum = {
	PROJECT_ID: "PROJECT_ID",
	WORK_GROUP: "WORK_GROUP",
	MODEL_REPOSITORY: "MODEL_REPOSITORY",
	CONTRACTOR_MANAGEMENT: "CONTRACTOR_MANAGEMENT",
	COSMOS: "COSMOS",
	COSMOS_FOR_DELETE: "COSMOS_FOR_DELETE",
	COSMOS_FOR_MIGRATE: "COSMOS_FOR_MIGRATE",
	ONTOLOGY_FILE_UPLOAD: "ONTOLOGY_FILE_UPLOAD",
	CLASSIFIER_TABLE_ROW: "CLASSIFIER_TABLE_ROW",
	ONTOLOGY_CLASSIFIER_TABLE: "ONTOLOGY_CLASSIFIER_TABLE",
	ONTOLOGY_CATALOG_DEFINITION: "ONTOLOGY_CATALOG_DEFINITION",
	ONTOLOGY_SFO_DEFINITION: "ONTOLOGY_SFO_DEFINITION",
	MODEL_PROPERTIES: "MODEL_PROPERTIES",
	EKPTD_RESOURCE: "EKPTD_RESOURCE",
	EKPTD_ROLE_APPLICATION: "EKPTD_ROLE_APPLICATION",
	EKPTD_REJECT_ROLE_APPLICATION: "EKPTD_REJECT_ROLE_APPLICATION",
	EKPTD_REVOKE_ROLE_APPLICATION: "EKPTD_REVOKE_ROLE_APPLICATION",
	LIBRARY: "LIBRARY",
	KNOWLEDGE_BASE: "KNOWLEDGE_BASE",
	EXTERNAL_REQUEST: "EXTERNAL_REQUEST",
	INTERNAL_REQUEST: "INTERNAL_REQUEST",
	INTERNAL_REQUEST_SUPPORTING: "INTERNAL_REQUEST_SUPPORTING",
	INTERNAL_REQUEST_TU_PART: "INTERNAL_REQUEST_TU_PART",
	INTERNAL_REQUEST_FINAL_DECISION: "INTERNAL_REQUEST_FINAL_DECISION",
	EXTERNAL_REQUEST_FINAL_DECISION: "EXTERNAL_REQUEST_FINAL_DECISION"
};
const fileMetaDtoTypeEnum = {
	DIRECTORY: "DIRECTORY",
	DOCUMENT: "DOCUMENT",
	CLASSIFIER_DOCUMENT: "CLASSIFIER_DOCUMENT",
	MODEL: "MODEL",
	MODEL_DATA: "MODEL_DATA",
	MODEL_DATA_SIMPLIFIED: "MODEL_DATA_SIMPLIFIED",
	IMAGE: "IMAGE",
	COMMENT_DOCUMENT: "COMMENT_DOCUMENT",
	COSMOS_DOCUMENT: "COSMOS_DOCUMENT",
	COSMOS_GEOSERVER_DOCUMENT: "COSMOS_GEOSERVER_DOCUMENT",
	BUILDING_MANAGEMENT_DOCUMENT: "BUILDING_MANAGEMENT_DOCUMENT",
	TASK_TRACKER: "TASK_TRACKER",
	MODEL_REPOSITORY: "MODEL_REPOSITORY",
	CONTRACTOR_MANAGEMENT: "CONTRACTOR_MANAGEMENT",
	ONTOLOGY_DOCUMENT: "ONTOLOGY_DOCUMENT",
	COLLISION_DOCUMENT: "COLLISION_DOCUMENT",
	ROLE_APPLICATION: "ROLE_APPLICATION",
	RESOURCE_DOCUMENT: "RESOURCE_DOCUMENT",
	LIBRARY_DOCUMENT: "LIBRARY_DOCUMENT",
	KNOWLEDGE_BASE_DOCUMENT: "KNOWLEDGE_BASE_DOCUMENT",
	REQUEST_DOCUMENT: "REQUEST_DOCUMENT",
	SUPPORTING_DOCUMENT: "SUPPORTING_DOCUMENT"
};
//#endregion
//#region src/__generated__/internal/application/types/FinalDecisionApprovalDto.ts
const finalDecisionApprovalDtoOutcomeEnum = {
	APPROVED: "APPROVED",
	RETURNED: "RETURNED"
};
const finalDecisionApprovalDtoStageEnum = {
	NTP: "NTP",
	NG: "NG"
};
//#endregion
//#region src/__generated__/internal/application/types/FinalDecisionBody.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const finalDecisionBodyDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/internal/application/types/FinalDecisionDto.ts
const finalDecisionDtoDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/internal/application/types/FinalDecisionRefusalDto.ts
const finalDecisionRefusalDtoDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/internal/application/types/FinalDecisionRemarkDto.ts
const finalDecisionRemarkDtoStageEnum = {
	NTP: "NTP",
	NG: "NG"
};
//#endregion
//#region src/__generated__/internal/application/types/FinalDecisionVersionDto.ts
const finalDecisionVersionDtoApprovalStatusEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
const finalDecisionVersionDtoDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/internal/application/types/GetFilterValues.ts
const getFilterValuesColumn = {
	SECTION: "SECTION",
	APPLICANT_NAME: "APPLICANT_NAME",
	INITIATOR: "INITIATOR",
	ASSIGNEE: "ASSIGNEE",
	OPERATOR: "OPERATOR"
};
const getFilterValuesMonitoringMetric = {
	TOTAL: "TOTAL",
	ACTIVE: "ACTIVE",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED",
	PAID_SERVICE: "PAID_SERVICE",
	FREE_SERVICE: "FREE_SERVICE",
	INVOICE_TOTAL: "INVOICE_TOTAL",
	PAYMENT_TOTAL: "PAYMENT_TOTAL",
	DEBT_TOTAL: "DEBT_TOTAL",
	ACTIVE_PLANNED: "ACTIVE_PLANNED",
	ACTIVE_APPROACHING: "ACTIVE_APPROACHING",
	ACTIVE_AT_RISK: "ACTIVE_AT_RISK",
	ACTIVE_OVERDUE: "ACTIVE_OVERDUE",
	ACTIVE_PAID_SERVICE: "ACTIVE_PAID_SERVICE",
	ACTIVE_FREE_SERVICE: "ACTIVE_FREE_SERVICE",
	ACTIVE_UNDEFINED_PAYMENT: "ACTIVE_UNDEFINED_PAYMENT",
	ACTIVE_AWAITING_INVOICE: "ACTIVE_AWAITING_INVOICE",
	ACTIVE_AWAITING_PAYMENT: "ACTIVE_AWAITING_PAYMENT",
	ACTIVE_PAID: "ACTIVE_PAID",
	ACTIVE_INVOICE_TOTAL: "ACTIVE_INVOICE_TOTAL",
	ACTIVE_PAYMENT_TOTAL: "ACTIVE_PAYMENT_TOTAL",
	ACTIVE_DEBT_TOTAL: "ACTIVE_DEBT_TOTAL"
};
//#endregion
//#region src/__generated__/internal/application/types/GetRequests.ts
const getRequestsStatusEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
const getRequestsType = {
	TU_ISSUE: "TU_ISSUE",
	TU_CHANGE: "TU_CHANGE",
	APPROVAL: "APPROVAL"
};
const getRequestsRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const getRequestsRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const getRequestsApplicantTypeEnum = {
	INDIVIDUAL: "INDIVIDUAL",
	SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
	LEGAL_ENTITY: "LEGAL_ENTITY"
};
const getRequestsPaymentFlagEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
const getRequestsProcessingFlagEnum = {
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
const getRequestsDeadlineControlEnum = {
	PLANNED: "PLANNED",
	DEADLINE_APPROACHING: "DEADLINE_APPROACHING",
	RISK_OF_VIOLATION: "RISK_OF_VIOLATION",
	OVERDUE: "OVERDUE",
	REVIEWED: "REVIEWED"
};
const getRequestsSortBy = {
	NUMBER: "NUMBER",
	TITLE: "TITLE",
	IMPORTED_AT: "IMPORTED_AT",
	REVIEW_DUE_DATE: "REVIEW_DUE_DATE",
	DEADLINE_CONTROL: "DEADLINE_CONTROL",
	CREATED_AT: "CREATED_AT",
	UPDATED_AT: "UPDATED_AT",
	TYPE: "TYPE",
	REQUEST_SUBJECT: "REQUEST_SUBJECT",
	STATUS: "STATUS",
	RAILWAY: "RAILWAY",
	SECTION: "SECTION",
	PAYMENT_FLAG: "PAYMENT_FLAG",
	INVOICE_AMOUNT: "INVOICE_AMOUNT",
	APPLICANT_NAME: "APPLICANT_NAME",
	INITIATOR: "INITIATOR",
	ASSIGNEE: "ASSIGNEE",
	OPERATOR: "OPERATOR",
	PROCESSING_FLAG: "PROCESSING_FLAG",
	RECEIVED_AT: "RECEIVED_AT",
	PROCESSED_AT: "PROCESSED_AT"
};
const getRequestsSortDir = {
	ASC: "ASC",
	DESC: "DESC"
};
const getRequestsMonitoringMetric = {
	TOTAL: "TOTAL",
	ACTIVE: "ACTIVE",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED",
	PAID_SERVICE: "PAID_SERVICE",
	FREE_SERVICE: "FREE_SERVICE",
	INVOICE_TOTAL: "INVOICE_TOTAL",
	PAYMENT_TOTAL: "PAYMENT_TOTAL",
	DEBT_TOTAL: "DEBT_TOTAL",
	ACTIVE_PLANNED: "ACTIVE_PLANNED",
	ACTIVE_APPROACHING: "ACTIVE_APPROACHING",
	ACTIVE_AT_RISK: "ACTIVE_AT_RISK",
	ACTIVE_OVERDUE: "ACTIVE_OVERDUE",
	ACTIVE_PAID_SERVICE: "ACTIVE_PAID_SERVICE",
	ACTIVE_FREE_SERVICE: "ACTIVE_FREE_SERVICE",
	ACTIVE_UNDEFINED_PAYMENT: "ACTIVE_UNDEFINED_PAYMENT",
	ACTIVE_AWAITING_INVOICE: "ACTIVE_AWAITING_INVOICE",
	ACTIVE_AWAITING_PAYMENT: "ACTIVE_AWAITING_PAYMENT",
	ACTIVE_PAID: "ACTIVE_PAID",
	ACTIVE_INVOICE_TOTAL: "ACTIVE_INVOICE_TOTAL",
	ACTIVE_PAYMENT_TOTAL: "ACTIVE_PAYMENT_TOTAL",
	ACTIVE_DEBT_TOTAL: "ACTIVE_DEBT_TOTAL"
};
//#endregion
//#region src/__generated__/internal/application/types/ImportItemResult.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importItemResultOutcomeEnum = {
	CREATED: "CREATED",
	UPDATED: "UPDATED",
	NO_CHANGE: "NO_CHANGE",
	CONFLICT: "CONFLICT",
	FAILED: "FAILED"
};
//#endregion
//#region src/__generated__/internal/application/types/ImportPayload.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const importPayloadFromEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
const importPayloadToEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/internal/application/types/InternalRequestDetailResponse.ts
const internalRequestDetailResponseAdjoiningTypeEnum = {
	DIRECT_RZD: "DIRECT_RZD",
	VIA_OTHER_OWNER: "VIA_OTHER_OWNER"
};
const internalRequestDetailResponseApplicantTypeEnum = {
	INDIVIDUAL: "INDIVIDUAL",
	SOLE_PROPRIETOR: "SOLE_PROPRIETOR",
	LEGAL_ENTITY: "LEGAL_ENTITY"
};
const internalRequestDetailResponseDeadlineControlEnum = {
	PLANNED: "PLANNED",
	DEADLINE_APPROACHING: "DEADLINE_APPROACHING",
	RISK_OF_VIOLATION: "RISK_OF_VIOLATION",
	OVERDUE: "OVERDUE",
	REVIEWED: "REVIEWED"
};
const internalRequestDetailResponseFinalDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
const internalRequestDetailResponsePaymentFlagEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
const internalRequestDetailResponsePlannedWorksTypeEnum = {
	NEW_TRACK_CONSTRUCTION: "NEW_TRACK_CONSTRUCTION",
	RECONSTRUCTION: "RECONSTRUCTION",
	RESTORATION: "RESTORATION",
	DEVELOPMENT: "DEVELOPMENT"
};
const internalRequestDetailResponseProcessingFlagEnum = {
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
const internalRequestDetailResponseRailwayEnum = {
	VOSTOCHNO_SIBIRSKAYA: "VOSTOCHNO_SIBIRSKAYA",
	GORKOVSKAYA: "GORKOVSKAYA",
	DALNEVOSTOCHNAYA: "DALNEVOSTOCHNAYA",
	ZABAYKALSKAYA: "ZABAYKALSKAYA",
	ZAPADNO_SIBIRSKAYA: "ZAPADNO_SIBIRSKAYA",
	KALININGRADSKAYA: "KALININGRADSKAYA",
	KRASNOYARSKAYA: "KRASNOYARSKAYA",
	KUYBYSHEVSKAYA: "KUYBYSHEVSKAYA",
	MOSKOVSKAYA: "MOSKOVSKAYA",
	OKTYABRSKAYA: "OKTYABRSKAYA",
	PRIVOLZHSKAYA: "PRIVOLZHSKAYA",
	SVERDLOVSKAYA: "SVERDLOVSKAYA",
	SEVERNAYA: "SEVERNAYA",
	SEVERO_KAVKAZSKAYA: "SEVERO_KAVKAZSKAYA",
	YUGO_VOSTOCHNAYA: "YUGO_VOSTOCHNAYA",
	YUZHNO_URALSKAYA: "YUZHNO_URALSKAYA"
};
const internalRequestDetailResponseRequestSubjectEnum = {
	ADJOINING: "ADJOINING",
	CROSSING: "CROSSING"
};
const internalRequestDetailResponseStatusEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
const internalRequestDetailResponseTrackFundingEnum = {
	APPLICANT_FUNDS: "APPLICANT_FUNDS",
	RZD_INVESTMENT: "RZD_INVESTMENT",
	SHARED: "SHARED",
	OTHER: "OTHER"
};
const internalRequestDetailResponseTypeEnum = {
	TU_ISSUE: "TU_ISSUE",
	TU_CHANGE: "TU_CHANGE",
	APPROVAL: "APPROVAL"
};
//#endregion
//#region src/__generated__/internal/application/types/InternalRequestEventLogDto.ts
const internalRequestEventLogDtoEventTypeEnum = {
	INTAKE_PASS: "INTAKE_PASS",
	REQUEST_REVISION: "REQUEST_REVISION",
	REJECT: "REJECT",
	TAKE_NG: "TAKE_NG",
	SEND_TO_NTP: "SEND_TO_NTP",
	TAKE_NTP: "TAKE_NTP",
	ASSIGN_NTP_RESP: "ASSIGN_NTP_RESP",
	START_COMMISSION_PREP: "START_COMMISSION_PREP",
	START_DECISION: "START_DECISION",
	SUBMIT_NTP_APPROVAL: "SUBMIT_NTP_APPROVAL",
	NTP_REWORK: "NTP_REWORK",
	NTP_APPROVE: "NTP_APPROVE",
	NG_REWORK: "NG_REWORK",
	NG_APPROVE: "NG_APPROVE",
	REWORK_RESUBMIT: "REWORK_RESUBMIT",
	ASSIGN: "ASSIGN",
	REASSIGN: "REASSIGN",
	IMPORTED: "IMPORTED",
	IMPORT_UPDATED: "IMPORT_UPDATED",
	RESUMED: "RESUMED",
	PAYMENT_CONFIRMED: "PAYMENT_CONFIRMED",
	EXPORT_RESULT: "EXPORT_RESULT",
	PAYMENT_FLAG_SET: "PAYMENT_FLAG_SET",
	INVOICE_ISSUED: "INVOICE_ISSUED",
	INVOICE_UPDATED: "INVOICE_UPDATED",
	INVOICE_SENT: "INVOICE_SENT",
	PAYMENT_AWAITING: "PAYMENT_AWAITING"
};
//#endregion
//#region src/__generated__/internal/application/types/PaymentFlagPayload.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const paymentFlagPayloadFromEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
const paymentFlagPayloadToEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
//#endregion
//#region src/__generated__/internal/application/types/StageAssignmentDto.ts
const stageAssignmentDtoSlotEnum = {
	NG_STAFF: "NG_STAFF",
	NTP_HEAD: "NTP_HEAD",
	NTP_RESPONSIBLE: "NTP_RESPONSIBLE"
};
//#endregion
//#region src/__generated__/internal/application/types/StatusChangePayload.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const statusChangePayloadDecisionEnum = {
	APPROVED: "APPROVED",
	REJECTED: "REJECTED"
};
const statusChangePayloadFromEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
const statusChangePayloadReturnStageEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
const statusChangePayloadToEnum = {
	INTAKE_CHECK: "INTAKE_CHECK",
	REVISION_REQUIRED: "REVISION_REQUIRED",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	IN_NTP: "IN_NTP",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NTP_APPROVAL: "NTP_APPROVAL",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	TU_ISSUED: "TU_ISSUED",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/__generated__/internal/application/types/TileCount.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const tileCountKeyEnum = {
	TOTAL: "TOTAL",
	NEW: "NEW",
	AT_NG: "AT_NG",
	AT_RAILWAY: "AT_RAILWAY",
	NEEDS_ATTENTION: "NEEDS_ATTENTION",
	OVERDUE_RISK: "OVERDUE_RISK",
	IN_NTP: "IN_NTP",
	NG_APPROVAL: "NG_APPROVAL",
	DECISION_REWORK: "DECISION_REWORK",
	SENT_TO_NG: "SENT_TO_NG",
	IN_NG: "IN_NG",
	SENT_TO_NTP: "SENT_TO_NTP",
	NTP_APPROVAL: "NTP_APPROVAL",
	NTP_RESP_ASSIGNED: "NTP_RESP_ASSIGNED",
	COMMISSION_PREP: "COMMISSION_PREP",
	DECISION_FORMING: "DECISION_FORMING",
	NEEDS_EXPORT: "NEEDS_EXPORT",
	EXPORTED: "EXPORTED",
	LOADED: "LOADED"
};
//#endregion
export { getRequestsRailwayEnum as A, finalDecisionRemarkDtoStageEnum as B, importPayloadToEnum as C, getRequestsMonitoringMetric as D, getRequestsDeadlineControlEnum as E, getRequestsType as F, finalDecisionApprovalDtoStageEnum as G, finalDecisionDtoDecisionEnum as H, getFilterValuesColumn as I, assignmentPayloadSlotEnum as J, fileMetaDtoSourceTypeEnum as K, getFilterValuesMonitoringMetric as L, getRequestsSortBy as M, getRequestsSortDir as N, getRequestsPaymentFlagEnum as O, getRequestsStatusEnum as P, finalDecisionVersionDtoApprovalStatusEnum as R, importPayloadFromEnum as S, getRequestsApplicantTypeEnum as T, finalDecisionBodyDecisionEnum as U, finalDecisionRefusalDtoDecisionEnum as V, finalDecisionApprovalDtoOutcomeEnum as W, internalRequestDetailResponseRailwayEnum as _, statusChangePayloadToEnum as a, internalRequestDetailResponseTrackFundingEnum as b, paymentFlagPayloadToEnum as c, internalRequestDetailResponseApplicantTypeEnum as d, internalRequestDetailResponseDeadlineControlEnum as f, internalRequestDetailResponseProcessingFlagEnum as g, internalRequestDetailResponsePlannedWorksTypeEnum as h, statusChangePayloadReturnStageEnum as i, getRequestsRequestSubjectEnum as j, getRequestsProcessingFlagEnum as k, internalRequestEventLogDtoEventTypeEnum as l, internalRequestDetailResponsePaymentFlagEnum as m, statusChangePayloadDecisionEnum as n, stageAssignmentDtoSlotEnum as o, internalRequestDetailResponseFinalDecisionEnum as p, fileMetaDtoTypeEnum as q, statusChangePayloadFromEnum as r, paymentFlagPayloadFromEnum as s, tileCountKeyEnum as t, internalRequestDetailResponseAdjoiningTypeEnum as u, internalRequestDetailResponseRequestSubjectEnum as v, importItemResultOutcomeEnum as w, internalRequestDetailResponseTypeEnum as x, internalRequestDetailResponseStatusEnum as y, finalDecisionVersionDtoDecisionEnum as z };

//# sourceMappingURL=TileCount.js.map